
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/speakers",
      function () {
        return require("private-next-pages/speakers/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/speakers"])
      });
    }
  